import { ArtworkItem } from 'src/components/Artwork/artwork.types';

export const filterCustomisations = (arr: ArtworkItem[], method: number) => {
    if (!method) return arr;
    return arr.filter((x) => x.application_method === method);
};
